// Global Types
import type {
  $Config as $SocketServiceConfig,
} from '@vroskus/library-socket/dist/browser';
import type {
  $Config as $MixpanelServiceConfig,
} from '@vroskus/library-mixpanel';
import type {
  $NavigationService,
} from '@vroskus/library-navigation';
import type {
  $SocketEventParams,
} from 'common.enums';

// Global Enums
import {
  DeploymentEnvironment,
  SocketEventType,
} from 'common.enums';

// Services
import CookiesService from '@vroskus/library-cookies/dist/browser';
import MixpanelService from '@vroskus/library-mixpanel/dist/browser';
import NavigationService from '@vroskus/library-navigation';
import SocketService from '@vroskus/library-socket/dist/browser';
import ApiService from './ApiService';
import TrackerService from './TrackerService';

// Helpers
import config, {
  packageName,
} from '../config';

// Mocks
import mockServices from './mocks';

// Types
import type {
  $Config as $ApiServiceConfig,
} from './ApiService';
import type {
  $Config as $TrackerServiceConfig,
} from './TrackerService';

export type $Services = {
  Api: ApiService<$ApiServiceConfig>;
  Cookies: CookiesService;
  LocalStorage: Storage;
  Mixpanel: MixpanelService<$MixpanelServiceConfig>;
  Navigation: $NavigationService;
  Socket: SocketService<$SocketServiceConfig, typeof SocketEventType, $SocketEventParams>;
  Tracker: TrackerService<$TrackerServiceConfig>;
};

const services = (): $Services => ({
  Api: new ApiService({
    apiUrl: `${config.API_URL}/v1.0`,
    timeout: Number(config.TIMEOUT) || 30000,
  }),
  Cookies: new CookiesService(),
  LocalStorage: localStorage,
  Mixpanel: new MixpanelService({
    serviceName: packageName,
    token: config.MIXPANEL_TOKEN,
  }),
  Navigation: NavigationService,
  Socket: new SocketService(
    {
      host: config.SOCKET_HOST,
    },
    SocketEventType,
  ),
  Tracker: new TrackerService({
    apiUrl: `${config.TRACKER_API_URL}/v1.0`,
    timeout: Number(config.TIMEOUT) || 30000,
  }),
});

const servicesToUse: $Services = config.DEPLOYMENT_ENV !== DeploymentEnvironment.test
  ? services()
  : mockServices();

if (window && config.DEPLOYMENT_ENV === DeploymentEnvironment.test) {
  window.Services = servicesToUse;
}

export default servicesToUse;
